/**
 * Canonical public origin for links the firm shares outside the
 * platform.
 *
 * Invite links, share URLs, and anything else we generate for a user
 * to send to a colleague gets built against `PUBLIC_ORIGIN` rather
 * than `window.location.origin`. That way an admin browsing on the
 * Cloudflare Pages preview URL (e.g. `agenticorganization.pages.dev`)
 * still sends invites pointing at the firm's branded host.
 *
 * The frontend reads `window.ERASPHERE_PUBLIC_ORIGIN` first — when
 * an operator wants to point invites at a different host (sister
 * office, staging) they can override it at deploy time via a
 * `<script>` injected by the server-side renderer or by editing
 * `index.html`. The hard-coded default is `https://erasphere.eu`.
 *
 * For server-generated URLs (Pages Functions), see the analogous
 * helper in `functions/_lib/public-origin.ts`.
 */
const DEFAULT_PUBLIC_ORIGIN = 'https://erasphere.eu';

export function publicOrigin() {
  if (typeof window !== 'undefined') {
    // Per-deploy override takes precedence (e.g. a staging deploy
    // that wants to send invites pointing at the staging host).
    const fromGlobal = (window as any).ERASPHERE_PUBLIC_ORIGIN;
    if (typeof fromGlobal === 'string' && fromGlobal.trim()) {
      return fromGlobal.replace(/\/+$/, '');
    }
  }
  return DEFAULT_PUBLIC_ORIGIN;
}
